import {LiteralUnionAutocomplete} from 'shared/web';

import {GetParticipationApiResponse} from '../sharedTypes';

export type SkipIdLiteral = 'SKIP';

export type ExcludeBranchesFromScope<T> = Exclude<
  T,
  'CASH_REGISTER_DOCUMENT.BRANCH' | 'INVOICE.BRANCH' | never
>;

enum InspectionTypeEnum {
  VALIDATION_INSPECTION = 'validationInspection',
  VEHICLE_CONDITION = 'vehicleCondition',
  NON_VALIDATION_INSPECTION = 'nonValidationInspection',
  AUTOFILL_TEMPLATE = 'autofillTemplate',
  CHECKIN = 'checkin',
  HANDOVER = 'handover',
  COMPLAINT = 'complaint',
}

type InspectionTypeLiteral = `${InspectionTypeEnum}`;
export type InspectionTypeConfig = {
  match: 'every' | 'some';
  values: InspectionTypeLiteral[];
};

enum InspectionStateEnum {
  FOR_CHECK = 'for_check',
  IN_PROGRESS = 'in_progress',
  FINISHED_AUDIT = 'finished_audit',
  TO_REVISION = 'to_revision',
  IN_REVISION = 'in_revision',
  TO_FINISHING = 'to_finishing',
}
type InspectionStateLiteral = `${InspectionStateEnum}`;
export type InspectionStateConfig = {
  match: 'every' | 'some';
  values: InspectionStateLiteral[];
};

type InspectionState = InspectionStateConfig | InspectionStateLiteral | SkipIdLiteral;

type InspectionType = InspectionTypeConfig | InspectionTypeLiteral | SkipIdLiteral;

// Helper type to dynamically merge all keys except the excluded ones
type MergeExcludingKeys<T, ExcludedKeys extends keyof T> = {
  [P in Exclude<keyof T, ExcludedKeys>]: T[P];
}[Exclude<keyof T, ExcludedKeys>];

export type ScopeValues = MergeExcludingKeys<
  RequestedValuesByScope,
  'CASH_REGISTER_DOCUMENT.BRANCH' | 'INVOICE.BRANCH'
>;

export type RequestedValuesByScope = {
  BRANCH: {
    branchId: LiteralUnionAutocomplete<SkipIdLiteral> | undefined;
  };
  'CASH_REGISTER_DOCUMENT.BRANCH': never;
  'INVOICE.BRANCH': never;
  PARTICIPATION: {
    participation:
      | LiteralUnionAutocomplete<SkipIdLiteral>
      | GetParticipationApiResponse
      | undefined;
  };
  SERVICE_CASE_TYPE: {
    serviceCaseType: string;
  };
  SERVICE_ORDER_TYPE: {
    serviceOrderType: string;
  };
  'CAR_AUDIT_INSPECTION.INSPECTION_TYPE': {
    inspectionType: InspectionType;
  };
  'CAR_AUDIT_INSPECTION.INSPECTION_STATE': {
    inspectionState: InspectionState;
  };
  INSPECTION_TYPE: {
    inspectionType: string;
  };
  PAYMENT_METHOD: {
    paymentMethod: string;
  };
  TIRE_WAREHOUSE: {
    tireWarehouses: SkipIdLiteral | string[];
  };
  BRANCH_SPECIFIC: {
    branchId: string;
  };
};

export type ScopeKeys = keyof RequestedValuesByScope;

export type ActionPermission = {
  resourceId: string;
  scopes: ScopeKeys[];
  actionId: string;
};

export type FieldPermission = {
  resourceId: string;
  scopes: ScopeKeys[];
  fieldId: string;
};

export type Permission = ActionPermission | FieldPermission;
